export enum LoginType {
  Internal = "#$internal",
  Google = "#$google"
}
